import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { base_url } from "./AgentWhitelist";
import "bootstrap/dist/css/bootstrap.min.css";

const GgrReport = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [casino, setCasino] = useState([]);
  const [fullCasino, setFullCasino] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [bets, setBets] = useState(0);
  const [wins, setWins] = useState(0);
  const [ggr, setGgr] = useState(0);
   const [ggrr, setGgrr] = useState(0);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const casinoData = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.get(base_url + "/api/webapi/ggrRepo", {
        headers: {
          Authorization: auth,
          "content-type": "application/json",
        },
      });


      console.log(response,"reooo")

      if (response?.data?.success) {
        const data = response?.data?.result || response?.data?.customers;

  if (Array.isArray(data)) {
  // e.g., take the first customer's ggr
  setGgrr(data[0]?.ggr);

  // OR map through all customers
  const ggrValues = data.map((cust) => cust.ggr);
  console.log(ggrValues, "All GGR values");
} else {
  // If it's a single object
  setGgrr(data?.ggr);
}

        const totals = data.reduce(
          (acc, bet) => {
            acc.amount += Number(bet.amount) || Number(bet.wallet) || 0;
            acc.ggr += Number(bet.ggr) || Number(bet.totalGGR) || 0;
            acc.wins += Number(bet.profit) || Number(bet.totalWin) || 0;
            return acc;
          },
          { amount: 0, ggr: 0, wins: 0 }
        );

        setCasino(data);
        setFullCasino(data);
        setBets(totals.amount);
        setWins(totals.wins);
        setGgr(totals.ggr);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleFilter = () => {
    let filteredData = [...fullCasino];

    // Filter by customerId, customername, or project_name
    if (search !== "") {
      filteredData = filteredData.filter((row) =>
        row.customerid?.toLowerCase().includes(search.toLowerCase()) ||
        row.customername?.toLowerCase().includes(search.toLowerCase()) ||
        row.project_name?.toLowerCase().includes(search.toLowerCase())
      );
    }

    // Filter by date range
    if (startDate && endDate) {
      const start = new Date(startDate + "T00:00:00");
      const end = new Date(endDate + "T23:59:59");

      filteredData = filteredData.filter((row) => {
        const rowDate = new Date(row.date || row.time);
        return rowDate >= start && rowDate <= end;
      });
    }

    setCasino(filteredData);
  };

  useEffect(() => {
    casinoData();
  }, []);

  useEffect(() => {
    handleFilter();
  }, [search, startDate, endDate]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Calculate total GGR %
  const totalGgrPercentage = wins ? ((ggr / wins) * 100).toFixed(2) : 0;

  return (
    <div className="wrapper bg-light min-vh-100">
      <AdminSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} isMobile={isMobile} />
      <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} isMobile={isMobile} />

      <div
        className={`content-wrapper p-3 ${!isMobile && isSidebarOpen ? "" : ""}`}
        style={{ marginLeft: !isMobile && isSidebarOpen ? "250px" : "0", transition: "margin-left 0.3s" }}
      >
        <div className="main-content">
          <div className="container-fluid py-4">
            <h3 className="mb-4 text-dark fw-bold">GGR Report</h3>

            {/* Search & Filter Section */}
            <div className="row g-3 mb-4">
              <div className="col-md-4">
                <input
                  type="text"
                  placeholder="Search by Customer ID, Name, or Project"
                  className="form-control"
                  value={search}
                  onChange={handleSearch}
                />
              </div>
       
            </div>

      

            {/* Data Table */}
            <div className="card border-0 shadow-sm">
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover table-striped mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="px-4 py-3">Customer ID</th>
                                                <th className="px-4 py-3">Phone</th>

                        <th className="px-4 py-3">Customer Name</th>
                        <th className="px-4 py-3">Project Name</th>
                        <th className="px-4 py-3">Total Wins</th>
                        <th className="px-4 py-3">Total Loss</th>
                        <th className="px-4 py-3">Total GGR</th>
                        <th className="px-4 py-3">Currency</th>
                        <th className="px-4 py-3">GGR %</th>
                        <th className="px-4 py-3">Wallet</th>
                      </tr>
                    </thead>
                    <tbody>
                    {casino.map((row, index) => {
  const totalLoss =
    (Number(row.totalWin) || 0) - (Number(row.totalGGR) || 0);

  return (
    <tr key={index}>
      <td className="px-4 py-3">{row.customerid}</td>
            <td className="px-4 py-3">{row.phone}</td>

      <td className="px-4 py-3">{row.customername}</td>
      <td className="px-4 py-3">{row.project_name}</td>
      <td className="px-4 py-3 text-success">
        {Number(row.totalWin || 0).toFixed(2)}
      </td>
      <td className="px-4 py-3 text-danger"> {Number(row.totalLoss || 0).toFixed(2)}</td>
      <td className="px-4 py-3 text-purple">
        {Number(row.totalGGR || 0).toFixed(2)}
      </td>
      <td className="px-4 py-3">{row.currency}</td>
      {/* Show ggr directly from response */}
      <td className="px-4 py-3 text-purple">
        {row.ggr ? `${row.ggr}%` : "0%"}
      </td>
      <td className="px-4 py-3">{Number(row.wallet || 0).toFixed(2)}</td>
    </tr>
  );
})}

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Inline CSS for custom styles */}
      <style>{`
        .text-purple {
          color: #6f42c1;
        }
        .wrapper {
          background-color: #f8f9fa;
        }
        .content-wrapper {
          transition: margin-left 0.3s ease-in-out;
        }
        .table th, .table td {
          vertical-align: middle;
        }
      `}</style>
    </div>
  );
};

export default GgrReport;